export const EPLEDGE_REQUEST_DETAILS = "EPLEDGE_REQUEST_DETAILS";
export const EPLEDGE_REQUEST_DETAILS_ERROR = "EPLEDGE_REQUEST_DETAILS_OTP_ERROR";
export const EPLEDGE_REQUEST_DETAILS_HIDE_ERROR = "EPLEDGE_REQUEST_DETAILS_HIDE_ERROR";
export const EPLEDGE_REQUEST_DETAILS_START_LOADER = "EPLEDGE_REQUEST_DETAILS_START_LOADER";
export const EPLEDGE_REQUEST_DETAILS_STOP_LOADER = "EPLEDGE_REQUEST_DETAILS_STOP_LOADER";
